<template>
  <div class="context-menu-item" @click="onClick">
    <span class="context-menu-icon-wrapper">
      <slot name="context-menu-item-icon"></slot>
    </span>

    <span class="context-menu-item-text aisea-text-14-400-black">{{
      text
    }}</span>
  </div>
</template>

<script>
export default {
  name: "ContextMenuItem",
  props: {
    icon: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.context-menu-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 170px;
  padding: 10px;
  gap: 12px;
  cursor: pointer;

  background-color: $aisea-white;

  &:hover {
    background-color: #c9e3fc;
  }
  &:active {
    background-color: #aee1ff;
  }

  .context-menu-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
  }
}
</style>
